import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import Lenis from 'lenis';

// Start Stimulus application
const application = Application.start()
const context = require.context('./controllers', true, /\.js$/)
application.load(definitionsFromContext(context));
application.debug = process.env.NODE_ENV === 'development';

import './css/app.scss';

// Automatically add all images to the manifest.json
const imagesCtx = require.context('./images', false, /\.(png|jpg|jpeg|gif|ico|svg|webp)$/);
imagesCtx.keys().forEach(imagesCtx);

// scrollbarWidth.js
const calculateScrollbarWidth = (function calculateScrollbarWidth() {
    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');

    return calculateScrollbarWidth;
})();

document.addEventListener('DOMContentLoaded', calculateScrollbarWidth); 
window.addEventListener('resize', calculateScrollbarWidth);
window.addEventListener('load', calculateScrollbarWidth);
document.documentElement.addEventListener('turbo:render', calculateScrollbarWidth);
document.documentElement.addEventListener('turbo:frame-render', calculateScrollbarWidth);

// Lenis
const lenis = new Lenis();

(function raf(time) {
    lenis.raf(time);
    window.requestAnimationFrame(raf);
    return raf;
})();

document.documentElement.addEventListener('turbo:render', () => lenis.resize());
document.documentElement.addEventListener('turbo:frame-render', () => lenis.resize());

// Menu fade
(function menuRaf(time) {
    const menu = document.querySelector('.ls2025-menu');
    const narrative = document.querySelector('.mod_article.article--ls-2025-narrative');

    if (menu && narrative) {
        if (narrative.getBoundingClientRect().top <= window.innerHeight * 0.5) {
            menu.classList.add('visible');
        } else {
            menu.classList.remove('visible');
        }
    }

    const links = menu.querySelectorAll('nav a');
    let activeLink = null;

    links.forEach((link) => {
        const url = new URL(link.href);

        if (!url.hash) {
            return;
        }

        const article = document.getElementById(url.hash.substring(1));

        if (article && article.getBoundingClientRect().top <= window.innerHeight * 0.5) {
            activeLink = link;
        }
    });

    if (!activeLink) {
        links.forEach(link => link.classList.remove('active'));
    } else {
        if (!activeLink.classList.contains('active')) {
            links.forEach(link => link.classList.remove('active'));
            activeLink.classList.add('active');
        }
    }

    window.requestAnimationFrame(menuRaf);
    return menuRaf;
})();
